module.exports = __webpack_public_path__ + "img/cover.a4563dcd.jpg";